<template>
  <v-app class="pa-0">
    <headerPlan 
      :appUserInfo="appUserInfo"
    />
    <v-container
      :class="{ 'pa-0 py-7 body': !isMobile && !isTablet, 'body-resp': isMobile || isTablet}"
    >
      <v-container
        class="pa-0 d-flex align-center justify-space-between mb-3"
      >
        <div>
          <v-card-text class="text-h4 pa-0">{{ $t('Purchase and renewal of subscription') }}</v-card-text>
          <v-card-text class="text-caption pa-0 mt-3">{{ $t('choose your subscription') }}</v-card-text>
        </div>
        <div>
          <v-btn
            color="secondary"
            outlined
            @click="chargingPanelSMS"
          >
          <svg class="ml-2" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.5003 11.3381C12.5871 11.3381 12.673 11.321 12.7531 11.2878C12.8332 11.2546 12.9061 11.206 12.9674 11.1446C13.0287 11.0833 13.0774 11.0105 13.1106 10.9304C13.1438 10.8502 13.1608 10.7643 13.1608 10.6776C13.1608 10.5909 13.1438 10.505 13.1106 10.4248C13.0774 10.3447 13.0287 10.2719 12.9674 10.2105C12.9061 10.1492 12.8332 10.1006 12.7531 10.0674C12.673 10.0342 12.5871 10.0171 12.5003 10.0171C12.3252 10.0171 12.1572 10.0867 12.0333 10.2105C11.9094 10.3344 11.8398 10.5024 11.8398 10.6776C11.8398 10.8528 11.9094 11.0208 12.0333 11.1446C12.1572 11.2685 12.3252 11.3381 12.5003 11.3381ZM17.1253 11.3381C17.2121 11.3381 17.298 11.321 17.3781 11.2878C17.4582 11.2546 17.5311 11.206 17.5924 11.1446C17.6537 11.0833 17.7024 11.0105 17.7356 10.9304C17.7688 10.8502 17.7858 10.7643 17.7858 10.6776C17.7858 10.5909 17.7688 10.505 17.7356 10.4248C17.7024 10.3447 17.6537 10.2719 17.5924 10.2105C17.5311 10.1492 17.4582 10.1006 17.3781 10.0674C17.298 10.0342 17.2121 10.0171 17.1253 10.0171C16.9502 10.0171 16.7822 10.0867 16.6583 10.2105C16.5344 10.3344 16.4648 10.5024 16.4648 10.6776C16.4648 10.8528 16.5344 11.0208 16.6583 11.1446C16.7822 11.2685 16.9502 11.3381 17.1253 11.3381ZM7.87534 11.3381C7.96208 11.3381 8.04797 11.321 8.12811 11.2878C8.20824 11.2546 8.28105 11.206 8.34239 11.1446C8.40372 11.0833 8.45237 11.0105 8.48557 10.9304C8.51876 10.8502 8.53584 10.7643 8.53584 10.6776C8.53584 10.5909 8.51876 10.505 8.48557 10.4248C8.45237 10.3447 8.40372 10.2719 8.34239 10.2105C8.28105 10.1492 8.20824 10.1006 8.12811 10.0674C8.04797 10.0342 7.96208 10.0171 7.87534 10.0171C7.70017 10.0171 7.53217 10.0867 7.4083 10.2105C7.28443 10.3344 7.21484 10.5024 7.21484 10.6776C7.21484 10.8528 7.28443 11.0208 7.4083 11.1446C7.53217 11.2685 7.70017 11.3381 7.87534 11.3381Z" fill="#0065FC" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21.75 10.9398V14.1098C21.7482 15.1626 21.3314 16.1723 20.59 16.9198C20.2171 17.284 19.7796 17.5756 19.3 17.7798C18.8201 17.9742 18.3078 18.076 17.79 18.0798H15.14L12.96 20.2598C12.8986 20.3208 12.8277 20.3715 12.75 20.4098C12.6708 20.4428 12.5858 20.4598 12.5 20.4598C12.4142 20.4598 12.3292 20.4428 12.25 20.4098C12.1723 20.3715 12.1014 20.3208 12.04 20.2598L9.86 18.0798H7.21C6.16064 18.0753 5.15504 17.6587 4.41 16.9198C3.6686 16.1723 3.25179 15.1626 3.25 14.1098V7.50977C3.25 6.4489 3.67143 5.43148 4.42157 4.68134C5.17172 3.93119 6.18913 3.50977 7.25 3.50977H13.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M19.0184 2.75V7.75M16.5234 5.255H21.5234" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
          </svg>
          {{ $t('plansSmsPanelCharge') }}
          </v-btn>
        </div>
      </v-container>
      
      <v-container 
        class="d-flex justify-center align-center pa-0" 
        :style="{ width: (!isMobile && !isTablet) ? '20%' : (isMobile || isTablet) ? 'auto' : '' }"
      >
        <v-container 
          v-if="plansVariant && plansVariant.length > 0" 
          class="pa-0 plan-variant-wrapper ma-0"
        >
          <div
            v-for="(variant, index) in plansVariant"
            :key="index"
            class="flex-fill pa-2 d-flex justify-center"
            @click="selectPlanVariant(variant)"
            :style="{
              'background-color': selectedPlanVariant == variant.persian_month ? '#0066ff' : '',
              'border-color': selectedPlanVariant == variant.persian_month ? '#0066ff' : 'silver',
              'color': selectedPlanVariant == variant.persian_month ? '#fff' : ''
            }"
          >
            <v-card-text
              class="pa-0 text-body-2 text-center"
            >
              {{ variant.persian_month }}
            </v-card-text>
          </div>
        </v-container>
      </v-container>
      <!--swiper-->
      <div class="my-swiper-wrapper relative mt-5">
        <swiper
          :options="swiperOptions"
          class="my-swiper"
          v-if="plans != undefined && plans != null"
        >
          <swiper-slide
            v-for="(plan, index) in plans"
            :key="index"
          >
            <plan
              :plan="plan"
              @visitCheckout="visitCheckout"
              @openMoreInfo="openMoreInfo"
            />
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination absolute left-1/2 bottom-0 transform -translate-x-1/2 z-10"></div>
      </div>
      <faq
        class="mt-9"
      />
    </v-container>
    <footerPlan />
    <v-dialog
      v-model="planInfo"
      width="375"
    >
      <v-card class="pa-4" v-if="singlePlan != undefined && singlePlan != null">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <div>
            <div class="d-flex justify-center">
              <img :src="singlePlan.icon" style="width: 50px;" />
            </div>
            <v-card-text class="pa-0 text-h5 mt-1 text-center" style="width: auto;">{{ singlePlan.name }}</v-card-text>
          </div>
          <div>
            <v-card-text class="text-h4 pa-0 text-left" style="width: auto;">{{ resolvePlanOriginPrice(singlePlan) }}</v-card-text>
            <v-container class="pa-0 d-flex justify-center gap-2 ma-0">
              <v-card-text
                  v-if="singlePlan.discounted != 0"
                  class="text-h5 pa-0"
                  style="color: red;width: auto;"
              >
                  {{ discountPercent }}
              </v-card-text>
              <v-card-text class="text-h5 pa-0" style="text-decoration: line-through;width: auto;">{{ resolveDiscount(singlePlan) }}</v-card-text>
            </v-container>
          </div>
        </v-container>
        <v-simple-table v-if="singlePlan.options && singlePlan.options.length > 0">
          <template v-slot:default>
            <table class="plain-table mt-3 mb-3">
              <tbody>
                <tr
                  v-for="(option, index) in singlePlan.options.slice(0, 3)"
                  :key="index"
                >
                  <td class="text-right font-weight-bold">{{ option.title }}</td>
                  <td class="text-left">{{ option.value }}</td>
                </tr>
                <tr
                  v-for="(option, index) in singlePlan.options.slice(3)"
                  :key="`${option.title}-${index}`"
                >
                  <td class="text-right font-weight-bold">{{ option.title }}</td>
                  <td
                    class="text-left"
                    style="font-weight: bold;"
                    :style="{ 'color': option.value == 'active' ? '#2e7d32' : 'red'}"
                  >
                  {{ option.value == 'active' ? $t('have') : $t('notHave') }}
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </v-simple-table>
        <v-btn
          color="success"
          class="w-100"
          :disabled="singlePlan.total_price <= 0"
          @click="confirmAndPay(singlePlan)"
        >
        {{ userCurrentPlan && userCurrentPlan.plan_id == singlePlan.id ? $t('renew-subscription') : $t('buy') }}
        </v-btn>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import headerPlan from '@/views/dashboard/pages/plans/partial/headerPlan.vue'
import plan from '@/views/dashboard/pages/plans/partial/plan.vue'
import faq from '@/views/dashboard/pages/plans/partial/faq.vue'
import footerPlan from '@/views/dashboard/pages/plans/partial/footerPlan.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      planInfo: false,
      swiperOptions: {
        slidesPerView: 5,
        centeredSlides: false,
        spaceBetween: 15,
        freeMode: true,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          768: {
            slidesPerView: 1.5,
            spaceBetween: 10
          },
          1024: {
            slidesPerView: 3.5,
            spaceBetween: 10
          }
        }
      },
      plans: null,
      plansVariant: null,
      singlePlan: null,
      userInfo: null,
      tokenUserApp: null,
      appUserInfo: null,
      selectedPlanVariant: null,
      discountPercent: null
    }
  },
  components: {
    headerPlan,
    plan,
    faq,
    footerPlan,
    swiper,
    swiperSlide
  },
  computed: {
    ...mapState(['userCurrentPlan'])
  },
  methods: {
    getServiceInfo () {
      var app = this
      app.loading = true
      delete this.$axios.defaults.headers.common.domain
      app.$axios.get(this.$endpoint + 'getdetail', {
        headers: {
          Authorization: 'Bearer ' + this.tokenUserApp,
          'mobile-application': 'android'
        },
        params: {
          select: 'getServiceInfo',
          search: null,
          page: 1
        }
      })
        .then(r => {
          this.appUserInfo = r.data
          if (this.appUserInfo) {
            localStorage.setItem('APP_KEY', this.appUserInfo.appKey)
          }
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => {
          app.loading = false
        })
    },
    fetchPlans () {
      var app = this
      delete this.$axios.defaults.headers.common.domain
      const endpoint = 'https://plans.abriron.com/api/'
      app.$axios.get(endpoint + 'plan-duration', {
        headers: {
          'X-API-KEY': 'ZEBQXqT6fYykTWRh9zhqJCBTtXfM1MXTmjIcYHw',
          abr: this.userInfo?.init?.appBarsOpacity?.abr,
          'Mobile-Application': (this.$route.query.token && this.$route.query.token != null) ? 'android' : 'web'
        }
      })
        .then(r => {
          this.plansVariant = r.data
          if (this.plansVariant) {
            this.selectedPlanVariant = this.plansVariant[0].persian_month
          }
        })
    },
    selectPlanVariant (variant) {
      this.selectedPlanVariant = variant.persian_month
    },
    visitCheckout (value) {
      this.singlePlan = this.plans.find(plan => plan.id == value.id)
      var isUserRenewPlan = false
      if (this.userCurrentPlan && this.userCurrentPlan.plan_id == value.id && this.userCurrentPlan.plan_duration_id == value.duration_id) {
        var isUserRenewPlan = true
      }
      this.$router.push({ name: 'PlansCheckout', query: { plan: this.singlePlan, token: this.tokenUserApp ? this.tokenUserApp : null, isUserRenewPlan: isUserRenewPlan, gateway: this.$route.query.gateway ? this.$route.query.gateway : null } })
    },
    resolvePlanOriginPrice (plan) {
      if (plan.discounted == 0) {
        if (plan.origin_price > 0) {
          return this.$numberFormat(plan.origin_price) + ' ' + this.$t('rial')
        }
        if (plan.origin_price == 0) {
          return this.$t('checkoutAddonFree')
        }
        if (plan.origin_price < 0) {
          return this.$t('contactus')
        }
      } else {
        return this.$numberFormat(plan.price_with_discount) + ' ' + this.$t('rial')
      }
    },
    resolveDiscount (plan) {
      if (plan.discounted != 0) {
        this.discountPercent = plan.discounted + '%' + this.$t('discount')
        return this.$numberFormat(plan.origin_price) + ' ' + this.$t('rial')
      }
    },
    openMoreInfo (planId) {
      this.planInfo = true
      this.singlePlan = this.plans.find(plan => plan.id == planId)
    },
    confirmAndPay (plan) {
      var isUserRenewPlan = false
      if (this.userCurrentPlan && this.userCurrentPlan.plan_id == plan.id) {
        var isUserRenewPlan = true
      }
      this.$router.push({ name: 'PlansCheckout', query: { plan, token: this.tokenUserApp ? this.tokenUserApp : null, isUserRenewPlan: isUserRenewPlan, gateway: this.$route.query.gateway ? this.$route.query.gateway : null } })
    },
    chargingPanelSMS () {
      this.$router.push({ name: 'PlansCheckout', query: { chargingSMS: true, token: this.tokenUserApp ? this.tokenUserApp : null, gateway: this.$route.query.gateway ? this.$route.query.gateway : null } })
    },
    fetchUserCurrentPlan (type) {
      if (type == 'app') {
        var app = this
        delete this.$axios.defaults.headers.common.domain
        app.$axios.get(app.$endpoint + 'get-user-plan', {
          headers: {
            Authorization: this.tokenUserApp ? 'Bearer ' + this.tokenUserApp : ''
          }
        })
          .then(r => {
            this.$store.commit('SET_USER_CURRENT_PLAN', r.data)
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      } else {
        var app = this
        delete this.$axios.defaults.headers.common.domain
        app.$axios.get(app.$endpoint + 'get-user-plan')
          .then(r => {
            this.$store.commit('SET_USER_CURRENT_PLAN', r.data)
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      }
    }
  },
  mounted () {
    if (this.$route.query.token) {
      this.tokenUserApp = this.$route.query.token
      if (this.tokenUserApp) {
        localStorage.setItem('token', JSON.stringify({ token: this.tokenUserApp }))
        if (localStorage.getItem('token')) {
          this.getServiceInfo()
          this.fetchPlans()
          this.fetchUserCurrentPlan('app')
        }
      }
    } else {
      this.userInfo = JSON.parse(localStorage.getItem('token'))
      this.fetchPlans()
      this.fetchUserCurrentPlan('web')
    }
  },
  watch: {
    selectedPlanVariant (val) {
      if (val) {
        this.plans = this.plansVariant.find(variant => variant.persian_month == val).plans
      }
    }
  }
}
</script>

<style scoped>
.body {
  padding-right: 150px !important;
  padding-left: 150px !important;
  background-color: #f3f3f3;
}
.body-resp {
  background-color: #f3f3f3;
}
.plain-table {
  width: 100%;
  border: 1px solid #ccc;
  border-collapse: collapse;
}
.plain-table td {
  padding: 8px;
  border: none;
}
.plain-table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}
.plain-table tbody tr:nth-child(even) {
  background-color: #f5f5f5;
}
.my-swiper {
  width: 100%;
  height: auto;
}
.swiper-wrapper {
  height: auto !important;
}
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
}
.swiper-container {
  overflow: visible;
}
.swiper-pagination {
  top: 58%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
}
.plan-variant-wrapper {
  border: 1px solid silver;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.plan-variant-wrapper > div {
  border-left: 1px solid silver;
  cursor: pointer;
}
.plan-variant-wrapper > div:last-child {
  border-left: 0 !important;
}
@media (min-width: 960px) {
  ::v-deep(.my-swiper .swiper-wrapper) {
    justify-content: center !important;
  }
}
</style>
